import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const CondolenceLogin = () => {
  const navigate = useNavigate();
  const [loginId, setLoginId] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    // 既にログイン済みならメニューへ
    fetch('/api/condolence/check', { credentials: 'include' })
      .then(res => res.ok ? res.json() : null)
      .then(data => {
        if (data && data.authenticated) {
          navigate(data.must_change ? '/condolence/change-password' : '/condolence/menu');
        }
      })
      .catch(() => {});
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSubmitting(true);

    try {
      const res = await fetch('/api/condolence/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ login_id: loginId, password }),
      });
      const data = await res.json();
      if (res.ok) {
        navigate(data.must_change ? '/condolence/change-password' : '/condolence/menu');
      } else {
        setError(data.error || 'ログインに失敗しました');
      }
    } catch {
      setError('通信エラーが発生しました');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="login-page" style={{ background: 'linear-gradient(135deg, #37474f 0%, #263238 100%)' }}>
      <div className="login-container">
        <div className="login-title">
          <h1>慶弔ポータル</h1>
          <p>訃報作成・供花手配</p>
        </div>

        {error && <div className="login-error">{error}</div>}

        <form className="login-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <label>ID</label>
            <input
              type="text"
              value={loginId}
              onChange={(e) => setLoginId(e.target.value)}
              placeholder="IDを入力"
              autoFocus
            />
          </div>
          <div className="form-group">
            <label>パスワード</label>
            <div style={{ position: 'relative' }}>
              <input
                type={showPassword ? 'text' : 'password'}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="パスワードを入力"
                style={{ paddingRight: '60px', width: '100%', boxSizing: 'border-box' }}
              />
              <button
                type="button"
                onClick={() => setShowPassword(v => !v)}
                aria-label={showPassword ? 'パスワードを隠す' : 'パスワードを表示'}
                style={{
                  position: 'absolute',
                  right: '8px',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  background: 'transparent',
                  border: 'none',
                  cursor: 'pointer',
                  color: '#546e7a',
                  fontSize: '12px',
                  padding: '4px 6px',
                }}
              >
                {showPassword ? '隠す' : '表示'}
              </button>
            </div>
          </div>
          <button
            type="submit"
            className="login-button"
            disabled={submitting}
            style={{ background: '#37474f' }}
          >
            {submitting ? 'ログイン中...' : 'ログイン'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default CondolenceLogin;
